import { render, staticRenderFns } from "./RoutingMachine.vue?vue&type=template&id=70afa50a&scoped=true"
import script from "./RoutingMachine.vue?vue&type=script&lang=js"
export * from "./RoutingMachine.vue?vue&type=script&lang=js"
import style0 from "./RoutingMachine.vue?vue&type=style&index=0&id=70afa50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afa50a",
  null
  
)

export default component.exports